import useFetch from 'core/redux/hooks/useFetch';
import fetchCards from 'app/games/whoisit/actions/fetchCards';

export default function useFetchCards() {
  return useFetch(fetchCards);
}
